import client from '.spat/modules/client';
import app from './scripts/app';
import './scripts/riot_mixin';

// ---- 多言語対応セットアップ ----
import i18next from 'i18next'
import ja from './plugins/translations/ja'
import en from './plugins/translations/en'

// sentry
import * as Sentry from "@sentry/browser";
// for Performance monitoring
// import { BrowserTracing } from "@sentry/tracing";

var environment = spat.config.sentry.environment;
if (environment) {
  Sentry.init({
    dsn: "https://fd4a3b53374c49d18bde2b051fec0370@o889670.ingest.sentry.io/6197338",
    // for Performance monitoring
    // integrations: [new BrowserTracing()],
    // tracesSampleRate: 0.2,
    environment,
  });
}
global.Sentry = Sentry;


const resources = { ja, en };
['ja', 'en'].forEach(lang => {
  // こういう構造なので translation 配下にネストする
  resources[lang] = {
    translation: resources[lang],
  };
});

i18next.init({
  fallbackLng: 'ja',
  resources,
  lng: global.navigator ? navigator.language.split('-')[0] : 'ja',
}, (err, t) => {
  if (err) {
    throw err;
  }
});

global.i18next = i18next;

global.t = (key, options) => {
  return i18next.t(key, options);
};
// ---- 多言語対応セットアップ終了 ----

// ユーザーが最後に設定した言語があれば、それを load
app.utils.loadLanguage();

// url に language 情報があれば changeLanguage を実行
var language = new URL(location.href).searchParams.get('lang');
if (language) {
  i18next.changeLanguage(language);
}

// client.showSSR();

app.auth.init(firebase);

// spat の初期化前のエラー
const callInitError = (e) => {
  console.error(e);
  alert('エラーが発生しました。\n時間をおいてから再度アクセスをお願いします。');
};

app.auth.on('ready', async (currentUser) => {
  var promises = [app.data.init()];
  try {
    await Promise.all(promises);
  }
  catch (e) {
    callInitError(e);
    return ;
  }
  // popup のセットアップ
  const $popup = document.createElement('div');
  spat.appTag.root.appendChild($popup);
  const popupTag = riot.mount($popup, 'module-popup')[0];
  spat.appTag.popupTag = popupTag;
  spat.popup = popupTag;
  
  // サインインしている時
  if (app.auth.isSignIn()) {
    try {
      // 必要に応じて処理追加 
      var { user, permission } = await app.store.users.signIn();
      app.utils.auth.currentUser = user;
      app.utils.auth.currentUser.permission = permission;
    }
    catch (e) {
      callInitError(e);
      return ;
    }
  }
  // 未ログインの時はauthページに飛ばす
  else if (location.pathname !== '/signin') {
    spat.router.push('/signin');
  }
  client.start();
});

app.auth.on('signin', async (e) => {
  const callError = (e) => {
    console.error(e);
    history.pushState(history.state, '', '/');
    spat.modal.alert('ユーザー情報の取得に失敗しました。\n時間をおいてから再度アクセスをお願いします。', 'エラーが発生しました');
  };

  // ログイン
  try {
    var { user, permission } = await app.store.users.signIn();
    app.utils.auth.currentUser = user;
    app.utils.auth.currentUser.permission = permission;
  }
  catch (e) {
    callError(e);
    return ;
  }
  // セッション切れ考慮 last seen の remove
  app.utils.removeLastSeenItem();
  
  if (user.role === 'operator') {
    spat.router.push('/admin/companies');
  }
  else if (user.role === 'client') {
    try {
      var { companies } = await app.api.child('me/companies').get({ limit: 1, offset: 0 });
      // とりあえず先頭のcompanyを表示させる
      var company = companies[0];
      spat.router.push(`/app/companies/${company.id}/projects`);
    }
    catch (e) {
      callError(e);
      return;
    }
  }

  // riot.update を実行する
  riot.update();
});

app.auth.on('signout', () => {
  app.utils.auth.currentUser = null;
  spat.router.push('/signin');
});
